import React from 'react'
import { useNavigation, useUndoRedo } from '@sketch-hq/sketch-prototype-player'
import { Tooltip } from '@sketch/components'
import {
  Container,
  Divider,
  Button,
  RestartIcon,
  GoForwardsButton,
  GoBackwardsButton,
} from './HistoryNavigation.styles'

type HistoryNavigationProps = {
  className?: string
  initialArtboardId: string
}

export function HistoryNavigation({
  className,
  initialArtboardId,
}: HistoryNavigationProps) {
  const { restartPrototypeFrom } = useNavigation()
  const { undo, redo, canUndo, canRedo } = useUndoRedo()

  return (
    <Container className={className}>
      <Tooltip
        placement="bottom"
        content="Restart Prototype"
        disabled={!canUndo}
      >
        <Button
          type="button"
          aria-label="Restart prototype"
          disabled={!canUndo}
          onClick={() => restartPrototypeFrom(initialArtboardId)}
        >
          <RestartIcon />
        </Button>
      </Tooltip>
      <Divider />
      <Tooltip placement="bottom" content="Undo" disabled={!canUndo}>
        <Button
          type="button"
          aria-label="Undo prototype action"
          disabled={!canUndo}
          onClick={undo}
        >
          <GoBackwardsButton />
        </Button>
      </Tooltip>
      <Tooltip placement="bottom" content="Redo" disabled={!canRedo}>
        <Button
          type="button"
          aria-label="Redo prototype action"
          disabled={!canRedo}
          onClick={redo}
        >
          <GoForwardsButton />
        </Button>
      </Tooltip>
    </Container>
  )
}
